import {Box, Center, createStyles, Tooltip} from '@mantine/core';
import React from 'react';
import type {NodeProps} from 'reactflow';
import {Handle, Position} from 'reactflow';

import {pluralize} from 'BenchlingUtil';
import {COMMON_NODE_WIDTH} from 'ui-library/reactflow/nodes/BenchlingNode/BenchlingNodeDesignConstants';

import type {CollapsedViewerNodeData} from './ReadOnlyFlowchartTypes';

const useStyles = createStyles((theme) => ({
  wrapper: {
    width: COMMON_NODE_WIDTH,
    justifyContent: 'center',
  },
  circle: {
    width: 24,
    height: 24,
    borderRadius: '50%',
    backgroundColor: theme.colors.gray[3],
    fontSize: theme.fontSizes.xs,
    lineHeight: '24px',
  },
  handle: {
    opacity: 0,
  },
}));

function ViewerCollapsedNodeRenderer(props: NodeProps<CollapsedViewerNodeData>): JSX.Element {
  const {classes} = useStyles();
  const {numNodesRepresented} = props.data;
  const tooltipText = `${numNodesRepresented} ${pluralize(
    numNodesRepresented,
    'node'
  )} without tasks ${pluralize(numNodesRepresented, 'is', 'are')} hidden from view`;

  return (
    <Box className={`${classes.wrapper} nopan`} display="flex" style={{pointerEvents: 'all'}}>
      <Handle type="target" position={Position.Top} id={`${props.id}-target`} className={classes.handle} />
      <Tooltip label={tooltipText} position="top-end">
        <Center className={classes.circle}>{numNodesRepresented}</Center>
      </Tooltip>
      <Handle type="source" position={Position.Bottom} id={`${props.id}-source`} className={classes.handle} />
    </Box>
  );
}

export default ViewerCollapsedNodeRenderer;
